import type { LatLng } from 'leaflet';
import { MapContainer, TileLayer } from 'react-leaflet';
import { REGEX_LATITUDE, REGEX_LONGITUDE } from '@/Constants';
import type { ILocation } from '@/Interfaces/Data';
import { MapLocationMaker } from './MapLocationMaker';

interface MapWithPinProps {
  mainPosition: ILocation;
  objectPosition?: ILocation;
  loadingMap?: boolean;
  zoom?: number;
  onChangePin(position: LatLng): void;
  popupLabel: string;
}

function MapWithPin({
  mainPosition,
  objectPosition,
  loadingMap = false,
  zoom = 5,
  onChangePin,
  popupLabel,
}: MapWithPinProps) {
  if (loadingMap) {
    return null;
  }

  if (
    objectPosition &&
    objectPosition.latitude.toPrecision &&
    !REGEX_LATITUDE.test(String(objectPosition.latitude.toPrecision(9)))
  ) {
    return null;
  }

  if (
    objectPosition &&
    objectPosition.longitude.toPrecision &&
    !REGEX_LONGITUDE.test(String(objectPosition.longitude.toPrecision(9)))
  ) {
    return null;
  }

  return (
    <MapContainer
      center={[mainPosition.latitude, mainPosition.longitude]}
      zoom={zoom}
      style={{ width: '100%', height: '100%', zIndex: 1 }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      <MapLocationMaker
        mainPosition={mainPosition}
        objectPosition={objectPosition}
        onChangePin={onChangePin}
        popupLabel={popupLabel}
      />
    </MapContainer>
  );
}

export default MapWithPin;
